import React, {useEffect} from 'react'
import {useLocation} from 'react-router'
import {Button} from '../../../components/Button/Button'
import {Logo} from '../../../components/Logo/Logo'
import {NavText} from '../../../components/NavElements'
import TextField from '../../../components/TextField/TextField'
import classes from './RegisterEmployee.module.css'
import {Formik, Form, ErrorMessage} from 'formik';
import * as Yup from 'yup';
import {useDispatch, useSelector} from "react-redux";
import {IUserData, setUserData} from "../../../State/Register/UserDataSlice";
import {useHistory} from "react-router-dom";
import {IRootState} from "../../../State/Store";
import ReactGA from 'react-ga'
interface Props {
}

export const RegisterEmployee: React.FC<Props> = () => {
    const {pathname} = useLocation()
    const UserData: IUserData | null = useSelector((s: IRootState) => s.UserData);
    const history = useHistory();
    useEffect(() => {
        window.scrollTo(0, 0)
        ReactGA.pageview(window.location.pathname)
    }, [pathname])
    const phoneRegExp = /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/
    const dispatch = useDispatch();
    return (
            <div className={classes.container}>
                <div className={classes.darker}>
                    <NavText to='/'><Logo/></NavText>
                    <div className={classes.headText}>
                        <p className={classes.mainText}>التسجيل كباحث عن وظيفة</p>
                        <p className={classes.text}>وظائف خالية في جميع المجالات فقط في مدينة السادات</p>
                    </div>

                    <div className={'animate__animated animate__fadeIns'}>
                        <Formik initialValues={{
                            name: UserData && UserData.name ? UserData.name : "",
                            phone: UserData && UserData.phone ? UserData.phone : "",
                            email: UserData && UserData.email ? UserData.email : "",
                            p_s: UserData && UserData.p_s ? UserData.p_s : "",
                        }} validationSchema={Yup.object().shape(
                                {
                                    name: Yup.string().min(4, 'برجاء ادخال الإسم كامل').max(40, 'برجاء ادخال الإسم بشكل صحيح').matches(/^\s*[\S]+(\s[\S]+)+\s*$/gms, 'برجاء ادخال الإسم كامل').required('برجاء ادخال الإسم كامل'),
                                    phone: Yup.string().max(11, 'برجاء ادخل رقم هاتف صحيح').min(11, 'برجاء ادخل رقم هاتف صحيح').required('برجاء ادخل رقم هاتفك').matches(phoneRegExp, 'برجاء ادخل رقم هاتف صحيح'),
                                    email: Yup.string().email(' برجاء ادخل بريد الأكتروني صحيح').required('برجاء ادخل بريدك الأكتروني'),
                                    p_s: Yup.string().min(8, 'برجاء ادخل كلمة مرور اكثر من 8 احرف').required('برجاء ادخل كلمة مرور'),
                                })}
                                onSubmit={async(Values: any) => {
                                    await dispatch(setUserData(Values))
                                    history.push('/employee/step')
                                }}
                        >
                            {({
                                  setFieldValue,
                                  handleSubmit,
                                  setFieldError,
                                  values
                              }) => (
                                    <Form className={'d-flex flex-column justify-content-center align-items-center'}>
                                        <div className={classes.formContainer + '  rtl'}>
                                            <TextField
                                                    containerStyle={{margin: 5}}
                                                    bgColor='#1D252D'
                                                    iconName={'FiUser'}

                                                    placeholder='الإسم'
                                                    width={200}
                                                    value={values.name}
                                                    handleChange={(e) => {
                                                        setFieldValue("name", e.target.value);
                                                    }}
                                            />

                                            <ErrorMessage name="name" className={classes.TextError} component="div"/>
                                            <TextField
                                                    containerStyle={{margin: 5}}
                                                    bgColor='#1D252D'
                                                    iconName={'FiMail'}

                                                    value={values.email}
                                                    placeholder='البريد الإلكتروني'
                                                    width={200}
                                                    handleChange={(e) => {
                                                        setFieldValue("email", e.target.value);
                                                    }}
                                            />
                                            <ErrorMessage name="email" className={classes.TextError} component="div"/>
                                            <TextField
                                                    containerStyle={{margin: 5}}
                                                    bgColor='#1D252D'
                                                    iconName={'FiPhone'}

                                                    value={values.phone}
                                                    placeholder='رقم الهاتف'
                                                    width={200}
                                                    handleChange={(e) => {
                                                        setFieldValue("phone", e.target.value);
                                                    }}

                                            />
                                            <ErrorMessage name="phone" className={classes.TextError} component="div"/>
                                            <TextField
                                                    containerStyle={{margin: 5}}
                                                    bgColor='#1D252D'
                                                    iconName={'FiLock'}
                                                    placeholder='كلمة المرور'

                                                    value={values.p_s}
                                                    width={200}
                                                    type='password'
                                                    handleChange={(e) => {
                                                        setFieldValue("p_s", e.target.value);
                                                    }}
                                            />
                                            <ErrorMessage name="p_s" className={classes.TextError} component="div"/>
                                        </div>

                                        <Button width={300} onPress={() => handleSubmit()}
                                                color='#5A8D59'>تسجيل</Button>
                                    </Form>
                            )}
                        </Formik></div>


                    <div style={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        width: 300,
                        justifyContent: 'space-around',
                        paddingRight: 30,
                        marginTop: 30
                    }}>
                        <NavText to='/login' style={{fontSize: 15, fontWeight: 200}}>تسجيل دخول</NavText>
                        <p style={{color: 'white', fontWeight: 200, paddingLeft: 15, paddingRight: 0}}>|</p>
                        <NavText to='/' style={{fontSize: 15, fontWeight: 200}}>الرئيسية</NavText>
                    </div>
                </div>
            </div>
    )
}